<script setup lang="ts">
  import { X } from "lucide-vue-next";
  import { Button } from "@/components/ui/button";
  import { useMAssetLibraryStore } from "@stores/mAssetLibrary";
  import ImageLibraryEditForm from "@/components/MCampaign/ImageLibrary/ImageLibraryEditForm.vue";

  const { setEditedAsset } = useMAssetLibraryStore();
</script>

<template>
  <aside class="flex flex-col overflow-hidden">
    <div class="flex items-center justify-between border-b px-4 py-3">
      <h3 class="heading-section">Edit asset</h3>
      <Button
        variant="ghost"
        size="icon"
        @click="setEditedAsset(null)">
        <X class="h-4 w-4" />
      </Button>
    </div>

    <ImageLibraryEditForm />
  </aside>
</template>
